import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
export const IMAGE_URL = `${process.env.REACT_APP_BASE_URL}/images/`;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const DataService = (token, contentType) => {
  return axios.create({
    baseURL: API_ENDPOINT,
    headers: {
      "Content-Type": contentType ?? "application/x-www-form-urlencoded",
      auth: token ? token : "",
    },
  });
};